export const initialState = {
  searchTerm: '',
  filteredPrompts: [],
};
